import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { MyProgress } from "@/features/my-progress/modules/my-progress/my-progress";
import { PROGRESS_TABS, type ProgressTab } from "@/features/my-progress/progress-tabs";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/progress/")({
  loader: () => ({ crumb: m.my_progress_title() }),
  // The tab lives in the URL, so a tab is a link and Back steps through them.
  validateSearch: z.object({ tab: z.enum(PROGRESS_TABS).optional().catch(undefined) }),
  component: ProgressPage,
});

function ProgressPage() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MyProgress
      tab={tab ?? "overview"}
      onTabChange={(next: ProgressTab) =>
        void navigate({ search: { tab: next === "overview" ? undefined : next }, replace: true })
      }
    />
  );
}
